module.exports = __webpack_public_path__ + "static/media/nike-logo-white.b8895a90.svg";